// extracted by mini-css-extract-plugin
module.exports = {"addButton":"Chips_addButton__1Zsj5"};